import {ModuleRegistry, provideGlobalGridOptions, RowDragModule} from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { mesfTheme } from "./ag-grid/mesf-theme";

const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE;

LicenseManager.setLicenseKey(licenseKey);

ModuleRegistry.registerModules([AllEnterpriseModule,RowDragModule]);
provideGlobalGridOptions({
	theme: mesfTheme,
});
